
<template lang="pug">
div.fit
  slot(v-if="show")
  NotFound(v-else)
</template>

<script>
import {get} from 'lodash-es'

import {mapAuto} from 'helpers/vuex-bind'

import NotFound from 'components/NotFound'

export default {
  components: {NotFound},

  computed: {
    ...mapAuto(['config']),

    show() {
      const role = get(this, '$route.meta.role')
      return role == null || role.includes(this.config.auth.role)
    },
  },
}
</script>
